<template>
<!-- 입과 불가자 리스트 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23">프로그램 추가 옵션</p>
                        <a class="pointer float-right layer-close ml-30" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <p class="font-13 pt-10 mt-10">
                            <input type="radio" class="mr-10 h-20px" v-model="type" value="P" /> 프로그램만 복사 
                        </p>
                        <p class="font-13 pt-10">
                            <input type="radio" class="mr-10 h-20px" v-model="type" value="A" /> 프로그램 내부 전체 복사 
                        </p>
                    </div>
                </div>
                <div class="modal-footer txt-center">
                    <a class="pointer admin-btn-default btn ml-05" data-dismiss="modal" aria-label="Close" @click="$emit('copy', type)">확인</a>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    data: () => ({
        type: 'P'
    }),

    mounted() {

    },

    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
